import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { Box, Card } from "@mui/material";
import i18next from 'i18next';
import { useTranslation } from "react-i18next";
import { useSelector } from 'react-redux';
import mobileQRcode from '../../../../assets/images/app-qr-code.png';
import appStore from '../../../../assets/images/app-store.png';
import mcKinsey from '../../../../assets/images/companies/McKinsey.png';
import amazon from '../../../../assets/images/companies/amazon.png';
import aramco from '../../../../assets/images/companies/aramco.png';
import hsbc from '../../../../assets/images/companies/hsbc.png';
import jpm from '../../../../assets/images/companies/jpm.png';
import pif from '../../../../assets/images/companies/pif.png';
import pwc from '../../../../assets/images/companies/pwc-logo.png';
import stc from '../../../../assets/images/companies/stc-logo.png';
import playStore from '../../../../assets/images/google-play.png';
import mobileApp from '../../../../assets/images/mobile-app.png';
import { BASE_URLS, IS_SA } from "../../../../config/appConfig";
import { AppRoutes } from "../../../../constants/appRoutes";
import { ObjectNameFormatter } from '../../../../helpers/objectNameFormatter';
import { LanguageService } from "../../../../services/languageService";
import Logo from '../../../../shared/components/common/logo';
import { TextWrapper } from '../../../../shared/components/formUtilities/useTextWrapper';
import { Platform } from "../../components/platform";

const logos = IS_SA ? [
  {
    path: jpm, className: "w-[110px]", style: {
      filter: 'brightness(0) invert(1) drop-shadow(#fdfffe 0.3px 0px 0px) drop-shadow(#fdfffe 0px 0.3px 0px)'
    }
  },
  {
    path: mcKinsey, className: "w-[118px]", style: {
      filter: 'brightness(0) invert(1) drop-shadow(rgb(253, 255, 254) 1px 0px 0px) drop-shadow(rgb(253, 255, 254) 0px 0.3px 0px)'
    }
  },
  { path: pif, className: "w-[75px]" },
  { path: aramco, className: "w-[79px]" },
  { path: stc, className: "w-[50px]" }
] :
  [{
    path: jpm, className: "w-[110px]", style: {
      filter: 'brightness(0) invert(1) drop-shadow(#fdfffe 0.3px 0px 0px) drop-shadow(#fdfffe 0px 0.3px 0px)'
    }
  },
  {
    path: mcKinsey, className: "w-[118px]", style: {
      filter: 'brightness(0) invert(1) drop-shadow(rgb(253, 255, 254) 1px 0px 0px) drop-shadow(rgb(253, 255, 254) 0px 0.3px 0px)'
    }
  },
  { path: amazon, className: "w-[75px]" },
  {
    path: hsbc, className: "w-[100px]", style: {
      filter: 'none'
    }
  },
  { path: pwc, className: "w-[61px] relative md:-top-[12px]" }];


export const SignupPageWrapper = ({ children, user = 'investor' }) => {
  const languageService = new LanguageService();
  const { settings } = useSelector(
    (state) => state.systemSettingsDataReducer
  );
  const { t } = useTranslation();

  const isInvestor = () => user === "investor";

  const showInvestorInfoText = () => {
    return !IS_SA && languageService.isArabic();
  };

  const getSaudiInvestorRegUrl = () => {
    return `${BASE_URLS.sa}/ar/${AppRoutes.InvestorRegistration}/register`;
  };

  const getContainerHeight = () => {
    if (settings && settings?.enabledWelcomeBonus && isInvestor()) {
      const bonus = ObjectNameFormatter(JSON.parse(settings?.enabledWelcomeBonus));
      return bonus?.enabled ? 'md:h-[calc(100vh-64px)]' : 'md:h-[100vh]';
    }
    return 'md:h-[100vh]';
  };

  const investorBasicInfoTemplate = () => {
    return <Box className={`flex flex-col space-y-6 ${i18next.language === 'ar' ? 'dir-rtl' : 'dir-ltr'}`}>
      {!isInvestor() ? <Box className='!text-[20px] !text-white'>{t('moveFasterGrow')}</Box> : null}
      <h2 className={`!font-[700] !text-white  ${!isInvestor() ? '!mt-2' : 'text-center mb-12 '} md:text-[30px] text-[26px]`}>
        {isInvestor() ? t('youAreInGoodCompany') : t('joinTopBusiness')}
      </h2>
      {!isInvestor() ? <Box>
        <Box className='text-white font-light md:max-w-[90%] mb-6'>{t('joinTopBusinessText')}</Box>
        <Box className='flex flex-col space-y-4'>
          <Box className="flex items-center !text-white">
            <CheckCircleOutlineOutlinedIcon />
            <Box className='mx-1'>{t('joinTopBusinessTextItem1')}</Box>
          </Box>
          <Box className="flex items-center !text-white">
            <CheckCircleOutlineOutlinedIcon />
            <Box className='mx-1'>{t('joinTopBusinessTextItem2')}</Box>
          </Box>
          <Box className="flex items-center !text-white">
            <CheckCircleOutlineOutlinedIcon />
            <Box className='mx-1'>{t('joinTopBusinessTextItem3')}</Box>
          </Box>
        </Box>
      </Box> : null}
    </Box>;
  };

  const investorDownloadAppTemplate = () => {
    return <Box className={`w-full flex relative flex-row md:items-start md:justify-center`}>
      <Box className={`flex flex-col md:max-w-[290px] relative md:w-auto w-full md:px-6 md:space-y-4 space-y-4 text-white ${i18next.language === 'ar' ? 'dir-rtl' : 'dir-ltr'}`}>
        <Box className='font-[600] !text-[18px] !text-center'>{t('registerInSeconds')}</Box>
        <img className="md:h-[165px] self-center p-2 bg-white rounded-md h-[140px] md:w-[165px] w-[140px]" src={mobileQRcode} alt="mobile-app"></img>
        <Box class="flex items-center justify-center gap-4 !my-3">
          <hr class="flex-grow border-t border-gray-300" />
          <span class="text-[12px] text-white">{t('or')}</span>
          <hr class="flex-grow border-t border-gray-300" />
        </Box>
        <Box className="flex cursor-pointer !mt-0 items-center justify-center gap-2 w-full max-w-sm mx-auto">
          <a className='w-1/2 bg-white h-[45px] md:h-auto flex items-center justify-center shadow-md p-[5px] rounded-[4px]' target='_blank' href='https://play.google.com/store/apps/details?id=com.fundingsouq&hl=en_IN' rel="noreferrer">
            <img className="max-w-[100px] h-auto bg-white" src={playStore} alt="Play Store" />
          </a>
          <a className='w-1/2 bg-white h-[45px] md:h-auto flex items-center justify-center shadow-md p-[5px] rounded-[4px]' target='_blank' href='https://apps.apple.com/us/app/funding-souq/id6739612948' rel="noreferrer">
            <img className="max-w-[100px] h-auto bg-white" src={appStore} alt="App Store" />
          </a>
        </Box>
      </Box>
      <Box className='xl:w-20 hidden md:block'></Box>
      <Box className='overflow-hidden'>
        <img className="xl:h-[310px] h-[280px] hidden md:block w-auto" src={mobileApp} alt="mobile-app"></img>
      </Box>
    </Box>;
  };

  const KSASignUp = () => {
    return <Box className="flex flex-col">
      <Box className="justify-center items-center flex flex-col">
        <Box className="reregistration-wrapper  m-auto flex-col overflow-auto md:p-2">
          <Box
            component={Card}
            className="registration-card relative !rounded-lg md:!px-10 md:!py-8 md:w-[430px] w-full">
            <Box
              className={`absolute ${languageService.isArabic() ? 'left-[24px]' : 'right-[24px]'
                }   top-[24px]`}>
              <Platform />
            </Box>
            <h1 className={`text-[24px] font-[500] mb-6 !text-center !mt-[34px]  ${IS_SA ? '!mt-16 md:!mt-8' : 'md:!mt-8'}`}>
              {t('letsGetStarted')}
              {showInvestorInfoText() ? <Box className='!text-sm'>
                <span>{t('switchToSaudi')}</span>
                <a href={getSaudiInvestorRegUrl()} className='mx-1'>{t('here')}</a>
              </Box> : null}
            </h1>

            {children}
          </Box>
        </Box>
      </Box>
    </Box>;
  };
  return IS_SA && isInvestor() ? KSASignUp() : <Box className="w-full flex items-center justify-center overflow-hidden bg-white">
    <Box className={`w-full flex md:flex-row-reverse flex-col-reverse shadow-[0_4px_12px_rgba(0,0,0,0.1)] rounded-md ${getContainerHeight()} auth-card-wrapper`}>
      <Box className='md:w-[50%] hidden relative md:flex flex-col justify-center items-center w-full overflow-auto md:p-[20px] p-6 primary-bg'>
        <Box className={`w-full ${isInvestor() ? 'md:max-w-[800px]' : 'md:max-w-[570px]'}`}>
          <Box>
            <Box className="overflow-hidden mt-12">
              <Box className={`${isInvestor() ? 'flex  flex-col md:items-center' : ''}`} dir='ltr'>
                <Box className={`${isInvestor() ? 'md:max-w-[600px]' : ''}`} >{investorBasicInfoTemplate()}</Box>
                {isInvestor() && <Box className='md:w-[120px]'></Box>}
                {isInvestor() ? investorDownloadAppTemplate() : null}
              </Box>
            </Box>
          </Box>
          <Box className='mt-14'>
            {isInvestor() ? <Box>
              <Box className="w-full text-center mb-6">
                <Box className="flex items-center justify-center gap-4">
                  <Box className="flex-1 h-[1.5px] bg-white opacity-50 md:flex hidden"></Box>
                  <TextWrapper classList="!text-[16px] !font-[600] !text-white whitespace-nowrap" text={t('backedByInvestors')} />
                  <Box className="flex-1 h-[1.5px] bg-white opacity-50 md:flex hidden"></Box>
                </Box>
              </Box>
              <Box className='md:flex md:flex-row md:gap-0 gap-6 grid grid-cols-3 justify-center'>
                {logos.map((resp, index) => {
                  return <Box className={`flex w-full relative ${index !== 0 ? 'justify-center' : ''}`}>
                    <img className={`${resp.className} self-center object-contain`}
                      style={resp?.style ? resp?.style : { filter: 'brightness(0) invert(1)' }}
                      alt="logo"
                      src={resp.path}></img>
                  </Box>;
                })}
                <Box className='font-bold text-[16px] !text-white mt-[12px] mx-4'>+{t('more')}</Box>
              </Box>
            </Box> : null}
            {isInvestor() ? <>
              <Box className={`flex items-center  md:text-start text-center justify-center !text-white !text-sm !font-[600] !mt-10`}>
                <Box>{t('regulatedBySAMA')}</Box>
                <span class="inline-block w-1 h-1  rounded-full bg-white mx-2"></span>
                <Box>{t('verifiedBySMEs')}</Box>
                <span class="inline-block w-1 h-1 rounded-full bg-white mx-2"></span>
                <Box>{t('shariahCompliantSignUp')}</Box>
              </Box>
            </> : null}
          </Box>
        </Box>
      </Box>
      <Box className='md:w-[50%] md:mt-0 mb-8 relative space-y-4 md:p-[60px] p-6 w-full bg-white flex flex-col justify-center items-center h-full'>
        <Box className='absolute top-0 py-4 px-6 w-full flex shadow-sm items-center justify-between '>
          <Box  >
            <Logo sx={{ height: "auto", width: 100 }} />
          </Box>
          <Platform />
        </Box>
        <Box className='md:max-w-[400px] w-full flex flex-col md:!mt-16 !mt-24'>
          <Box>
            <h2 className={`mb-8 md:mb-6 !text-center md:text-[30px] text-[26px] !font-[700] !text-[#9d9d9d]`}>{t('letsGetStarted')}</h2>
          </Box>
          {showInvestorInfoText() ? <Box className='!text-sm'>
            <span>{t('switchToSaudi')}</span>
            <a href={getSaudiInvestorRegUrl()} className='mx-1 !text-sm'>{t('here')}</a>
          </Box> : null}
          <Box className='xl:min-w-[380px] w-full'>
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  </Box>;
};